export const RequestUnserviceableHistoryHeaders = [
  {
    header: "PN",
    key: "PN",
    width: 25,
  },
  {
    header: "SN",
    key: "SN",
  },
  {
    header: "AWB",
    key: "AWB",
  },
  {
    header: "AC",
    key: "AC",
  },
  {
    header: "FLIGHT NO",
    key: "FLIGHT NO",
  },
  {
    header: "BATCH",
    key: "BATCH",
  },
  {
    header: "TSO",
    key: "TSO",
  },
  {
    header: "CSO",
    key: "CSO",
  },
  {
    header: "TSR",
    key: "TSR",
  },
  {
    header: "CSR",
    key: "CSR",
  },
  {
    header: "TSN",
    key: "TSN",
  },
  {
    header: "CSN",
    key: "CSN",
  },
  {
    header: "DSN",
    key: "DSN",
  },
  {
    header: "TSI",
    key: "TSI",
  },
  {
    header: "CSI",
    key: "CSI",
  },
  {
    header: "DSI",
    key: "DSI",
  },
  {
    header: "DSO",
    key: "DSO",
  },
  {
    header: "DSR",
    key: "DSR",
  },
  {
    header: "ESTIMATED DELIVERY DATE",
    key: "ESTIMATED DELIVERY DATE",
  },
  {
    header: "FORWARD DATE TO CARRIER",
    key: "FORWARD DATE TO CARRIER",
  },
  {
    header: "REMOVE DATE FROM AC",
    key: "REMOVE DATE FROM AC",
  },
  {
    header: "REMOVE REASON TYPE",
    key: "REMOVE REASON TYPE",
  },
  {
    header: "REMOVE REASON SUB TYPE",
    key: "REMOVE REASON SUB TYPE",
  },
  {
    header: "CARRIER",
    key: "CARRIER",
  },
  {
    header: "STATUS",
    key: "STATUS",
  },
  {
    header: "REMARK",
    key: "REMARK",
  },
  {
    header: "REMOVAL REASON DETAIL",
    key: "REMOVAL REASON DETAIL",
  },
  {
    header: "DOM",
    key: "DOM",
  },
  {
    header: "AD/SB/MOD",
    key: "AD/SB/MOD",
  },
  {
    header: "NLA",
    key: "NLA",
  },
  {
    header: "NHA",
    key: "NHA",
  },
  {
    header: "REPLENISHMENT REASON",
    key: "REPLENISHMENT REASON",
  },
  {
    header: "REJECTION REMARK",
    key: "REJECTION REMARK",
  },
  {
    header: "CREATED BY",
    key: "CREATED BY",
  },
  {
    header: "UPDATED BY",
    key: "UPDATED BY",
  },
  {
    header: "CREATED DATE",
    key: "CREATED DATE",
  },
  {
    header: "UPDATED DATE",
    key: "UPDATED DATE",
  },
];

export const RequestUnserviceableHistoryExcelName = "Unserviceable History";

export const RequestServiceableHistoryHeaders = [
  {
    header: "CREATED BY",
    key: "CREATED BY",
    width: 25,
  },
  {
    header: "CREATED DATE",
    key: "CREATED DATE",
  },
  {
    header: "UPDATED BY",
    key: "UPDATED BY",
  },
  {
    header: "UPDATED DATE",
    key: "UPDATED DATE",
  },
  {
    header: "PN",
    key: "PN",
  },
  {
    header: "SN",
    key: "SN",
  },
  {
    header: "AWB",
    key: "AWB",
  },
  {
    header: "FLIGHT NO",
    key: "FLIGHT NO",
  },
  {
    header: "REQUESTED DELIVERY DATE",
    key: "REQUESTED DELIVERY DATE",
  },
  {
    header: "ESTIMATED DELIVERY DATE",
    key: "ESTIMATED DELIVERY DATE",
  },
  {
    header: "SUBMITTED BY",
    key: "SUBMITTED BY",
  },
  {
    header: "SUBMITTED DATE",
    key: "SUBMITTED DATE",
  },
  {
    header: "CARRIER",
    key: "CARRIER",
  },
  {
    header: "FLIGHT DATE",
    key: "FLIGHT DATE",
  },
];

export const RequestServiceableHistoryExcelName = "Serviceable History";

export const RequestOrderHistoryHeaders = [
  {
    header: "REF NO",
    key: "REF NO",
    width: 25,
  },
  {
    header: "IS DEFINED",
    key: "IS DEFINED",
  },
  {
    header: "REQUESTED DELIVERY DATE",
    key: "REQUESTED DELIVERY DATE",
  },
  {
    header: "CHAPTER",
    key: "CHAPTER",
  },
  {
    header: "RELEASE TYPE",
    key: "RELEASE TYPE",
  },
  {
    header: "AIRPORT CODE",
    key: "AIRPORT CODE",
  },
  {
    header: "CUSTOMER PO",
    key: "CUSTOMER PO",
  },
  {
    header: "CUSTOMER PO LINE",
    key: "CUSTOMER PO LINE",
  },
  {
    header: "CREATED BY",
    key: "CREATED BY",
  },
  {
    header: "UPDATED BY",
    key: "UPDATED BY",
  },
  {
    header: "CREATED DATE",
    key: "CREATED DATE",
  },
  {
    header: "UPDATED DATE",
    key: "UPDATED DATE",
  },
  {
    header: "PN",
    key: "PN",
  },
  {
    header: "COMPONENT DESCRIPTION",
    key: "COMPONENT DESCRIPTION",
  },
  {
    header: "ACCESS",
    key: "ACCESS",
  },
  {
    header: "REPAIR",
    key: "REPAIR",
  },
  {
    header: "IS POOL",
    key: "IS POOL",
  },
  {
    header: "REPAIR TAT",
    key: "REPAIR TAT",
  },
  {
    header: "RECEIVED DATE",
    key: "RECEIVED DATE",
  },
  {
    header: "TRANSACTION TYPE",
    key: "TRANSACTION TYPE",
  },
];

export const RequestOrderHistoryExcelName = "Request Order History";

export const PbhRequestOrderHistoryExcelName = "Pbh Request Order History";

export const PbhRequestOrderHistoryHeaders = [
  {
    header: "REF NO",
    key: "REF NO",
    width: 25,
  },
  {
    header: "REQUESTED DELIVERY DATE",
    key: "REQUESTED DELIVERY DATE",
  },
  {
    header: "CHAPTER",
    key: "CHAPTER",
  },
  {
    header: "RELEASE TYPE",
    key: "RELEASE TYPE",
  },
  {
    header: "AIRPORT CODE",
    key: "AIRPORT CODE",
  },
  {
    header: "CUSTOMER PO",
    key: "CUSTOMER PO",
  },
  {
    header: "CUSTOMER PO LINE",
    key: "CUSTOMER PO LINE",
  },
  {
    header: "CREATED BY",
    key: "CREATED BY",
  },
  {
    header: "UPDATED BY",
    key: "UPDATED BY",
  },
  {
    header: "CREATED DATE",
    key: "CREATED DATE",
  },
  {
    header: "UPDATED DATE",
    key: "UPDATED DATE",
  },
  {
    header: "PN",
    key: "PN",
  },
  {
    header: "PN DESCRIPTION",
    key: "PN DESCRIPTION",
  },
  {
    header: "ACCESS",
    key: "ACCESS",
  },
  {
    header: "REPAIR",
    key: "REPAIR",
  },
  {
    header: "IS POOL",
    key: "IS POOL",
  },
];
